import classNames from 'classnames';
import IconError from '@public/next/ui-kit/input/error.svg';

import styles from './FormField.module.scss';

interface ErrorTypeProps {
  error?: string;
  className?: string;
}

export const Error = ({ error, className }: ErrorTypeProps) => {
  return (
    <div className={classNames(styles.Error, error && styles.Show, className)}>
      <div className={styles.Message}>
        <IconError /> {error}
      </div>
    </div>
  );
};
